"use strict";

exports.__esModule = true;
exports.TYPE_OPTIONS = exports.SIZE_OPTIONS = void 0;
let TYPE_OPTIONS = /*#__PURE__*/function (TYPE_OPTIONS) {
  TYPE_OPTIONS["PRIMARY"] = "primary";
  TYPE_OPTIONS["SECONDARY"] = "secondary";
  TYPE_OPTIONS["SUCCESS"] = "success";
  TYPE_OPTIONS["INFO"] = "info";
  TYPE_OPTIONS["WARNING"] = "warning";
  TYPE_OPTIONS["CRITICAL"] = "critical";
  TYPE_OPTIONS["WHITE"] = "white";
  return TYPE_OPTIONS;
}({});
exports.TYPE_OPTIONS = TYPE_OPTIONS;
let SIZE_OPTIONS = /*#__PURE__*/function (SIZE_OPTIONS) {
  SIZE_OPTIONS["SMALL"] = "small";
  SIZE_OPTIONS["NORMAL"] = "normal";
  SIZE_OPTIONS["LARGE"] = "large";
  SIZE_OPTIONS["EXTRA_LARGE"] = "extraLarge";
  return SIZE_OPTIONS;
}({});
exports.SIZE_OPTIONS = SIZE_OPTIONS;